<template>
<div :key="routerKey" id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import cookies from "js-cookie";

export default {
  name: "File",
  computed: {
    ...mapState({
      isPcMode: (state) => state.isPcMode,
    }),
    routerKey() {
      return JSON.stringify(this.$route.query);
    },
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions(["setIsPcMode"]),
  },
  created() {
    this.setIsPcMode();
  },
  mounted() {},
};
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
}

html,
body,
#app {
  height: 100%;
}

#app {
  margin: 0;
  padding: 0;
  width: 100vw;
  min-width: 0px;
}
</style>
